module.exports = require('./dist/commonjs/index.js').default;



//////////////////
// WEBPACK FOOTER
// ../node_modules/i18next-xhr-backend/index.js
// module id = 418
// module chunks = 0 1